import React from 'react';
import { useEffect, useState } from 'react';
import './App.css';

function App() {
  const [quote, setQuote] = useState(null);
  useEffect(() => {
    async function getQuote() {
      const res = await fetch('/api/quote');
      const newQuote = await res.text();
      setQuote(newQuote);
    }
    getQuote();
  }, []);
  return (
    <main>
      <h1>Shitty Quotes App</h1>
      <br />
      <p>
        An unsophisticated project by the unsophisticated minds.
      </p>
      <p>
        Visit <a href="/api/quote">
          <code>api/quote</code> to get a random shitty quote.
        </a>
      </p>
      <h2>Your quote of the moment is:</h2>
      <h3>{quote ? quote : 'Loading quote...'}</h3>
    </main>
  );
}

export default App;
